import { StaffAccess } from '../modules/auth/pages/StaffAccess';
import { createBrowserRouter } from 'react-router-dom';
import { Dashboard } from '../modules/dashboard/pages/dashboard';
import { Layout } from '../components/Layout';
import { Activate } from '../modules/dashboard/pages/activate';
import { CameraDetails } from '../modules/cameras/pages/CameraDetails';
import { Subscription } from '../modules/subscription/page/subscription';
import { Invoices } from '../modules/invoices/page/invoices';
import { Login } from '../modules/auth/pages/Login';
import { LoginToken } from '../modules/auth/pages/LoginToken';
import { Pricing } from '../modules/invoices/page/pricing';
import { PostCodeChecker } from '../modules/postcodeChecker/pages/PostCodeChecker';
import { SignalCheck } from '../modules/postcodeChecker/pages/SignalCheck';
import { ThankYou } from '../modules/invoices/page/ThankYou';
import { TeamLogin } from '../modules/auth/pages/TeamLogin';
import { AdminSelectUser } from '../modules/auth/pages/AdminSelectUser';
import { SimHealth } from '../modules/auth/pages/SimHealth';
import { NotFound } from '../components/NotFound';
import { Livestreaming } from '../modules/livestreaming/pages/Livestreaming';
import { LivestreamingSetup } from '../modules/livestreaming/pages/LivestreamingSetup';
import { CombinedDataUsage } from '../modules/dashboard/pages/CombinedDataUsage';
import { TradeLogin } from '../modules/trade/pages/TradeLogin';
import { TradeRegister } from '../modules/trade/pages/TradeRegister';
import { TradeLoginToken } from '../modules/trade/pages/TradeLoginToken';
import { TradeDashboard } from '../modules/trade/pages/TradeDashboard';
import { Tools } from '../modules/tools/pages/Tools';
import { CameraMigrations } from '../modules/migrations/CameraMigrations';
import { GroupActivation, PrepayEntry } from '../modules/groupActivation/GroupActivation';
import { GroupConversion } from '../modules/groupActivation/GroupConversion';
import { GroupActivationTeam } from '../modules/groupActivation/GroupActivationTeam';

export const router = createBrowserRouter([
  { path: '/team/access', element: <StaffAccess /> },
  { path: "/team/migrations", element: <CameraMigrations key="checks" /> },
  { path: "/team/migrations/install", element: <CameraMigrations key="install" installation /> },
  { path: "/team/camera-diagnostics", element: <CameraMigrations key="diagnostics" diagnostics /> },
  { path: "/team", element: <TeamLogin /> },
  {
    path: '/team/group-activations',
    element: <GroupActivationTeam />
  },
  {
    path: '/activate/group',
    element: <GroupActivation />
  },
  {
    path: '/activate/prepay',
    element: <PrepayEntry />
  },
  {
    path: '/activate/group/add',
    element: <GroupConversion />
  },
  {
    path: '',
    element: <Login />
  },
  {
    path: 'login',
    element: <Login />
  },
  {
    path: 'login/:token',
    element: <LoginToken />
  },
  {
    path: 'postcode',
    element: <PostCodeChecker />
  },
  {
    path: 'postcode/:postcode',
    element: <SignalCheck />
  },
  {
    path: '/order-confirmation',
    element: <ThankYou />
  },
  {
    path: 'team-login',
    element: <TeamLogin />
  },
  {
    path: 'admin/select-user',
    element: <AdminSelectUser />
  },
  {
    path: 'callum',
    element: <SimHealth />
  },
  {
    path: 'tools',
    element: <Tools />
  },
  {
    path: 'trade',
    element: <TradeLogin />
  },
  {
    path: 'trade-reg',
    element: <TradeRegister />
  },
  {
    path: 'trade/login/:token',
    element: <TradeLoginToken />
  },
  {
    path: 'trade/dashboard',
    element: <TradeDashboard />
  },
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: 'dashboard',
        element: <Dashboard />
      },
      {
        path: 'data-usage',
        element: <CombinedDataUsage />
      },
      {
        path: 'activate',
        element: <Activate />
      },
      {
        path: 'livestreaming',
        element: <Livestreaming />
      },
      {
        path: 'livestreaming/setup',
        element: <LivestreamingSetup />
      },
      {
        path: 'camera/:cameraId',
        element: <CameraDetails />
      },
      {
        path: 'subscription/:stripeId',
        element: <Subscription />
      },
      {
        path: 'invoices/:stripeId',
        element: <Invoices />
      },
      {
        path: 'pricing/:iccid/:customerId',
        element: <Pricing />
      }
    ]
  },
  {
    path: '*',
    element: <NotFound />
  }
]);
